import { Navigate, Route, Routes } from 'react-router-dom';
import { AuthGuard } from './auth/AuthGuard';
import { AppLayout } from './components/AppLayout';
import { ToastProvider } from './hooks/useToast';
import { ClassementPage } from './pages/ClassementPage';
import { DeclarerPage } from './pages/DeclarerPage';
import { MesVentesPage } from './pages/MesVentesPage';
import { ProfilPage } from './pages/ProfilPage';

export function App() {
  return (
    <ToastProvider>
      <AuthGuard>
        <Routes>
          <Route element={<AppLayout />}>
            <Route index element={<Navigate to="/declarer" replace />} />
            <Route path="declarer"   element={<DeclarerPage />} />
            <Route path="ventes"     element={<MesVentesPage />} />
            <Route path="classement" element={<ClassementPage />} />
            <Route path="profil"     element={<ProfilPage />} />
            <Route path="*" element={<Navigate to="/declarer" replace />} />
          </Route>
        </Routes>
      </AuthGuard>
    </ToastProvider>
  );
}
